export default `
<button class="slide-up-close" ng-click="toggleSlideUp()" aria-label="Close">
  <i class="material-icons" aria-hidden="true">close</i>
</button>
<div class="slide-up-content" ng-transclude>
</div>
`;
